var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyecapBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_53134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 21C25.7911 21 26.5645 21.2346 27.2223 21.6741C27.8801 22.1136 28.3928 22.7384 28.6955 23.4693C28.9983 24.2002 29.0775 25.0044 28.9231 25.7804C28.7688 26.5563 28.3878 27.269 27.8284 27.8284C27.269 28.3878 26.5563 28.7688 25.7804 28.9231C25.0044 29.0775 24.2002 28.9983 23.4693 28.6955C22.7384 28.3928 22.1136 27.8801 21.6741 27.2223C21.2346 26.5645 21 25.7911 21 25H19C18.9996 25.9704 18.6465 26.9077 18.0063 27.637C17.3662 28.3664 16.4827 28.8382 15.5205 28.9644C14.5583 29.0907 13.583 28.8629 12.7764 28.3234C11.9697 27.7839 11.3866 26.9696 11.1359 26.0321C10.8851 25.0946 10.9837 24.0979 11.4133 23.2278C11.8429 22.3576 12.5741 21.6732 13.4709 21.3023C14.3676 20.9313 15.3686 20.8989 16.2874 21.2113C17.2062 21.5236 17.9802 22.1594 18.465 23H21.535C21.886 22.3917 22.3911 21.8865 22.9993 21.5354C23.6076 21.1843 24.2977 20.9996 25 21ZM15 23C14.4696 23 13.9609 23.2107 13.5858 23.5858C13.2107 23.9609 13 24.4696 13 25C13 25.5304 13.2107 26.0391 13.5858 26.4142C13.9609 26.7893 14.4696 27 15 27C15.5304 27 16.0391 26.7893 16.4142 26.4142C16.7893 26.0391 17 25.5304 17 25C17 24.4696 16.7893 23.9609 16.4142 23.5858C16.0391 23.2107 15.5304 23 15 23ZM25 23C24.4696 23 23.9609 23.2107 23.5858 23.5858C23.2107 23.9609 23 24.4696 23 25C23 25.5304 23.2107 26.0391 23.5858 26.4142C23.9609 26.7893 24.4696 27 25 27C25.5304 27 26.0391 26.7893 26.4142 26.4142C26.7893 26.0391 27 25.5304 27 25C27 24.4696 26.7893 23.9609 26.4142 23.5858C26.0391 23.2107 25.5304 23 25 23ZM24 11C25.0609 11 26.0783 11.4214 26.8284 12.1716C27.5786 12.9217 28 13.9391 28 15V18H30V20H10V18H12V15C12 13.9391 12.4214 12.9217 13.1716 12.1716C13.9217 11.4214 14.9391 11 16 11H24ZM24 13H16C14.946 13 14 13.95 14 15V18H26V15C26 13.946 25.05 13 24 13Z",
    fill: "#3F7CDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_53134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyecapBlue);
export default __webpack_public_path__ + "static/media/eyecap_blue.ae2a7d633eb6c9ce90851d059873affc.svg";
export { ForwardRef as ReactComponent };